import { types } from "./types";

export const increaseLoadingCounter = () => ({
  type: types.INCREASE_LOADING_COUNTER
});
export const decreaseLoadingCounter = () => ({
  type: types.DECREASE_LOADING_COUNTER
});
